import { Injectable } from "@angular/core";
import ICompin from "@models/compin.interface";
import { ApiService } from "./api.service";
import { IResponseAPI } from "@models/responseAPI.interface";
import { DangerError } from "@shared/errors/custom.error";
import { TerminologiaService } from "./terminologia.service";
import { environment } from "@env/environment";

@Injectable({
    providedIn: "root",
})
export class CompinService {
    constructor(private apiService: ApiService, private terminologiaService: TerminologiaService) {}

    async obtenerCompinesPorRegion(idRegion: number): Promise<ICompin[]> {
        const { data, msg, success } =
            await this.apiService.privatePost<IResponseAPI<string[]>>(
                `obtener-compines-region`,
                {
                    idRegion,
                }
            );

        if (!success || data.length === 0) throw new DangerError(msg);
        const idCompines = data[0].split(',').filter(c => c !== "").map(Number);
        return this.terminologiaService.obtenerCompinesPorID(idCompines);
    }
}